module.exports = __webpack_public_path__ + "static/img/basecotrl.4e898d79.svg";